const hyphencase = value => value
  .toLowerCase()
  .replace(/[^\w ]+/g, '')
  .replace(/_/g, '-')
  .replace(/ +/g, '-');

export default hyphencase;
